class AnnouncementBar {
  constructor(configs) {
    this.configs = configs;
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupEventListeners();
  }

  _getElements() {
    const container = document.querySelector(this.configs.selectors.announcementBar);
    return container ? {
      container,
      closeButtons: container.querySelectorAll(this.configs.selectors.closeButton),
      body: document.querySelector(this.configs.selectors.body),
      header: document.querySelector(this.configs.selectors.header),
      announcementMessage: container.querySelector(this.configs.selectors.textMessage),
      announcementBarSection: document.querySelector(this.configs.selectors.announcementBarSection)
    } : {};
  }

  _setupEventListeners() {
    for (const closeButton of this.elements.closeButtons) {
      closeButton.addEventListener('click', this._handleCloseButtonClick);
    }
  }

  _toggleClosed(target) {
    target.setAttribute(this.configs.attributes.closed, true);
  }

  _handleCloseButtonClick = () => {
      this.elements.container.parentNode.classList.add("annnouncement-bar-is-removed");
      this._toggleClosed(this.elements.announcementMessage);
  }

  isTablet() {
    return window.innerWidth < 1200;
  }
}
